export const channelNav = [
  { label: "实时", hot: true },
  { label: "今日曝光" },
  { label: "娱乐内幕" },
  { label: "商业深挖" },
  { label: "现场实况" },
  { label: "人物专题" },
];

export const topStory = {
  badge: "今日焦点",
  kicker: "全网同步跟进中",
  title: "顶流剧组杀青夜突曝全员换角，幕后合同与番位明细接连流出",
  summary:
    "原定下月官宣的主演阵容在杀青夜当晚被临时叫停，多份带有签字与备注的选角备忘在多个渠道流传，涉及的档期、片酬与宣传条款细节引发全网逐帧比对，官方至今保持沉默。",
  meta: "8 分钟前",
  category: "娱乐 · 新爆料",
  read: "12.6万 人在跟进",
  image: "https://readdy.ai/api/search-image?query=breaking%20news%20press%20briefing%20room%20at%20night%20with%20many%20microphones%20and%20flashing%20camera%20lights%2C%20silhouettes%20of%20journalists%2C%20moody%20red%20and%20amber%20stage%20lighting%2C%20editorial%20photojournalism%2C%20grainy%20cinematic%2C%20dramatic%20high%20contrast%2C%20warm%20tones%2C%20no%20text&width=1200&height=800&seq=hero-topstory-2026&orientation=landscape",
};

export const liveTicker = [
  { time: "刚刚", text: "财经圈流出疑似并购双方内部估值邮件，分歧点被逐条圈注" },
  { time: "3 分钟前", text: "某访谈未剪辑母带片段现网络，主持人一句提问被反复解读" },
  { time: "7 分钟前", text: "新开播剧集首更卡点引热议，弹幕与平台数据双双走高" },
  { time: "12 分钟前", text: "品牌方深夜更博疑似回应此前代言风波的网友置顶留言" },
  { time: "19 分钟前", text: "某活动后台视频流出，两位嘉宾短暂同框被逐帧慢放" },
  { time: "26 分钟前", text: "行业通告被曝删改条款，涉及排期与结算的表述变化引关注" },
];

export const flashFeed = [
  { time: "08:47", tag: "独家", title: "剧组副导深夜连发三条状态又秒删，被指暗指选角变局", read: "2.1万" },
  { time: "08:39", tag: "实锤", title: "公开登记信息显示某新锐公司法人同日完成两处变更", read: "1.7万" },
  { time: "08:31", tag: "视频", title: "机场接机大屏循环播放宣传片，画外音惊现未官宣名字", read: "3.4万" },
  { time: "08:22", tag: "新爆料", title: "导演采访提及下个项目时欲言又止，主持人眼神被网友放大", read: "0.9万" },
  { time: "08:14", tag: "深挖", title: "一份早年合作协议截图被重新翻出，签约笔迹引发讨论", read: "2.6万" },
  { time: "08:05", tag: "现场", title: "发布会大合影站位被重新排序，团队换人消息再添佐证", read: "4.2万" },
];

export const hotRank = [
  { rank: 1, title: "全员换角风声起，谁是临阵接手的新班底", heat: "刷屏" },
  { rank: 2, title: "未播访谈母带流出，一句提问被反复解读", heat: "热议" },
  { rank: 3, title: "公司法人同日两变更，注册地同日迁址", heat: "发酵" },
  { rank: 4, title: "新剧首更卡点，平台与片方数据双双走高", heat: "关注" },
  { rank: 5, title: "机场宣传片惊现未官宣名字，接机人群沸腾", heat: "热" },
  { rank: 6, title: "早年合作协议截图翻出，笔迹引网友鉴定", heat: "追" },
  { rank: 7, title: "活动后台同框慢放，两人站位被逐格分析", heat: "热议" },
  { rank: 8, title: "宣传排期临时变动，多地路演被标记延期", heat: "留意" },
  { rank: 9, title: "品牌深夜更博回应置顶留言，措辞被称话里有话", heat: "新" },
  { rank: 10, title: "杀青夜全员合照缺席主角，评论区炸开锅", heat: "爆" },
];

export const featured = [
  {
    tag: "娱乐内幕",
    tone: "crimson",
    title: "红毯与摄影棚之外，一线团队真实的番位博弈",
    summary: "从选角备忘到宣传位排序，台前光鲜背后是层层约定。整理多方信源，还原一份节目排期如何一改再改。",
    meta: "深度 · 9 分钟读完",
    image: "https://readdy.ai/api/search-image?query=theater%20stage%20backstage%20corridor%20with%20bright%20spotlights%2C%20silhouette%20figure%20walking%20away%2C%20deep%20crimson%20curtain%2C%20cinematic%20editorial%20photography%2C%20warm%20amber%20highlights%2C%20dramatic%20high%20contrast%2C%20no%20text&width=900&height=640&seq=feat-stage-2026&orientation=landscape",
  },
  {
    tag: "商业深挖",
    tone: "gold",
    title: "并购传闻里的估值拉锯，邮件里的那句红线",
    summary: "一份被圈注的估值分歧清单，让桌面上的数字变得有温度。条款逐条拆解，看看资本方真正在意的是什么。",
    meta: "调查 · 11 分钟读完",
    image: "https://readdy.ai/api/search-image?query=city%20skyline%20at%20dusk%20seen%20from%20high%20office%20window%2C%20scattered%20financial%20documents%20and%20calculator%20on%20desk%20in%20warm%20blurred%20foreground%2C%20golden%20amber%20window%20light%2C%20editorial%20business%20news%20photography%2C%20moody%20warm%20tones%2C%20no%20text&width=900&height=640&seq=feat-city-2026&orientation=landscape",
  },
  {
    tag: "人物专题",
    tone: "ink",
    title: "一夜之间走完红毯的他，退场时说了句没人听见的话",
    summary: "聚光灯照不到的时刻往往最真实。回看几次公开行程，拼出一位从业者浮沉背后的那些细节与抉择。",
    meta: "特写 · 12 分钟读完",
    image: "https://readdy.ai/api/search-image?query=investigative%20desk%20scene%20with%20scattered%20papers%20magnifying%20glass%20and%20pen%2C%20single%20warm%20desk%20lamp%20light%2C%20dark%20moody%20background%2C%20cinematic%20editorial%2C%20amber%20and%20crimson%20highlights%2C%20no%20text&width=900&height=640&seq=feat-desk-2026&orientation=landscape",
  },
];

export const liveGallery = [
  { title: "发布会现场：站位临时重排，全程不到四十秒", tag: "现场实况", duration: "01:26", view: "38.2万" },
  { title: "话筒递到嘴边又收回，那段同期声被消掉了什么", tag: "同期声", duration: "00:58", view: "21.6万" },
  { title: "后台错身而过，两人对视的零点几秒被逐帧放慢", tag: "独家镜头", duration: "02:11", view: "54.9万" },
  { title: "散场后独自留下的身影，被拍到在原地站了很久", tag: "跟拍", duration: "03:04", view: "12.3万" },
];

export const galleryThumbs = [
  "https://readdy.ai/api/search-image?query=crowd%20of%20paparazzi%20camera%20flashes%20outside%20a%20building%20at%20night%2C%20silhouettes%2C%20warm%20red%20and%20amber%20neon%20glow%2C%20cinematic%20editorial%2C%20motion%20energy%2C%20no%20text&width=800&height=540&seq=vid-crowd-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=audio%20recorder%20and%20professional%20microphone%20close%20up%20on%20a%20desk%2C%20single%20warm%20lamp%20light%2C%20moody%20editorial%20photography%2C%20deep%20shadows%20amber%20tones%2C%20no%20text&width=800&height=540&seq=vid-mic-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=long%20hotel%20corridor%20with%20two%20silhouetted%20figures%20passing%20each%20other%2C%20warm%20amber%20bokeh%20lights%2C%20cinematic%20tension%2C%20editorial%20noir%20style%2C%20no%20text&width=800&height=540&seq=vid-corridor-2026&orientation=landscape",
  "https://readdy.ai/api/search-image?query=single%20figure%20standing%20alone%20on%20an%20empty%20evening%20stage%2C%20single%20warm%20followspot%20from%20above%2C%20crimson%20velvet%20background%2C%20moody%20cinematic%20editorial%2C%20no%20text&width=800&height=540&seq=vid-alone-2026&orientation=landscape",
];

export const editorPick = [
  { col: "独家内幕", items: ["杀青夜全员合照独缺主角，评论区已炸", "节目宣传排期临改，三地路演被标记延期", "番位排序备忘录流出，片方暂无回应", "访谈母带流出背后：谁拿到了未剪辑原片"] },
  { col: "今天在聊", items: ["新剧首更卡点讨论为何如此上头", "品牌深夜更博，一句措辞被称话里有话", "机场循环宣传片，画外音惊现未官宣名", "某评审席位上的一句话被反复循环"] },
  { col: "线索征集", items: ["你有现场图或同期声？私信投稿直通编辑部", "同一场活动拍到不同角度的朋友举个手", "整理回忆录式爆料需附凭证与时间线", "匿名投稿将做脱敏处理后再跟进"] },
];

export const searchHot = ["换角", "估值分歧", "母带流出", "番位", "首更卡点", "机场宣传片"];

export const footerChannels = ["今日曝光", "实时动态", "娱乐内幕", "商业深挖", "现场实况", "人物专题"];

export const footerAbout = [
  "关于我们",
  "投稿与线索",
  "版权合作",
  "纠错与投诉",
  "免责声明",
  "隐私政策",
];